// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appContainer {
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  min-height: 100vh;
  overflow-y: auto;
}

.contentContainer {
  margin-top: 56px;
}

.contentContainer,
.appContainer {
  overflow: visible !important;
}

/* Large screens (1224px and above) */
@media (min-width: 1224px) {
  .contentContainer.withSubmenuOpen {
    margin-left: 400px;
  }

  .contentContainer.withSubmenuClosed {
    margin-left: 280px;
    margin-right: 100px;
  }
}

/* Medium screens (1223px and below) */
@media (max-width: 1223px) {
  .contentContainer {
    margin-left: 100px;
  }
}

/* Small screens (816px and below) */
@media (max-width: 816px) {
  .contentContainer {
    margin-left: 0px;
  }
  /* .contentContainer.withSubmenuClosed {
    margin-left: 20px;
  } */
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA,qCAAqC;AACrC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,gBAAgB;EAClB;EACA;;KAEG;AACL","sourcesContent":[".appContainer {\n  display: flex;\n  flex-direction: column;\n  overflow-x: hidden;\n  min-height: 100vh;\n  overflow-y: auto;\n}\n\n.contentContainer {\n  margin-top: 56px;\n}\n\n.contentContainer,\n.appContainer {\n  overflow: visible !important;\n}\n\n/* Large screens (1224px and above) */\n@media (min-width: 1224px) {\n  .contentContainer.withSubmenuOpen {\n    margin-left: 400px;\n  }\n\n  .contentContainer.withSubmenuClosed {\n    margin-left: 280px;\n    margin-right: 100px;\n  }\n}\n\n/* Medium screens (1223px and below) */\n@media (max-width: 1223px) {\n  .contentContainer {\n    margin-left: 100px;\n  }\n}\n\n/* Small screens (816px and below) */\n@media (max-width: 816px) {\n  .contentContainer {\n    margin-left: 0px;\n  }\n  /* .contentContainer.withSubmenuClosed {\n    margin-left: 20px;\n  } */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
